import ITenantInfo from "../responses/ITenantInfo";

export default class Tenant {
  constructor(
    public id: number,
    public code: string,
    public name: string,
    public info: ITenantInfo
  ) {
  }
}
